import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { mutations } from './mutations';
import { getters } from './getters';
import { NoteReclamationState, state } from '@/modules/NoteReclamation/store/state';

const module: Module<NoteReclamationState, RootState> = {
    namespaced: true,
    state,
    mutations,
    getters,
};

export default module;
export type { NoteReclamationState };

